<div id="faq-category" class="bordered-select-field">
    <span>{{label}}</span>
    <mat-form-field appearance="fill">
        <mat-select matSelect [formControl]="helpTypeControl">
            <mat-select-trigger>
                <div class="mat-select-content">
                    <mat-icon color="primary" *ngIf="helpTypeControl.value?.IconFont">
                        {{helpTypeControl.value?.IconFont}}</mat-icon>
                       {{helpTypeControl.value?.Value}}
                </div>
            </mat-select-trigger>
            <mat-option *ngFor="let category of categories" [value]="category">
                <mat-icon color="primary" *ngIf="category.IconFont">{{category.IconFont}} </mat-icon>
                {{category.Value}}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>
